module.exports = __webpack_public_path__ + "door-icon.3c113b6bf3810ad784be.svg";


//////////////////
// WEBPACK FOOTER
// C:/unnati/latestWebCode29march/src/assets/images/door-icon.svg
// module id = ../../../../../src/assets/images/door-icon.svg
// module chunks = main